// @ts-expect-error object-fit-images is not typescript compatible
import objectFitImages from 'object-fit-images';

import '../../components/hero-top-image/hero-top-image';
import '../../blocks/fullwidth-blocks/fullwidth-blocks';

const htmlElement = document.getElementsByTagName('html').item(0);
const classes = htmlElement?.getAttribute('class');
if (classes && classes?.indexOf('landing-content-page') > -1) {
  objectFitImages('picture .hero-image__image');
}
